<template>
    <div class="m-bot">
        <div class="s-li">服务热线:&nbsp;&nbsp;0755-86952970</div>
        <div class="ul-t">公司地址</div>
        <div class="su-t">深圳地址：深圳市南山区科技园讯美科技广场3号楼402</div>
        <div class="su-t">洛阳地址：河南省洛阳市涧西区国家大学科技园A-3栋4层</div>
        <div class="block flex tflex">
            <div class="img" style="margin-right: 40px;"><img class="code-img" src="@/assets/images/ercode01.png" alt=""><div class="name">极智数科公众号</div></div>
            <div class="img"><img class="code-img" src="@/assets/images/ercode02.png" alt=""><div class="name">极智BIM软件技术服务群</div></div>
        </div>
        <div style="display:block;margin-top:2rem;text-align: center;font-size: .38rem;">深圳市极智数字科技有限公司</div>
        <a href="https://beian.miit.gov.cn/" style="display:block;margin-top:.2rem;text-align: center;font-size: .35rem;">粤ICP备2021053912号-3</a>
    </div>
</template>
<script>
export default {
    data() {
        return{

        }
    },
}
</script>
<style lang="less" scoped>
.m-bot{
    margin-top:2rem;
    height: auto;
    background-color: #333;
    color: #FFF;
    padding: 1rem;
    box-sizing: border-box;
}
.s-li{
    font-size: .5rem;
    padding: .5rem 0;
    text-align: center;
}
.ul-t{
    font-size: .7rem;
    
}
.su-t{
    padding-top: .2rem;
    font-size: .45rem;
}
.block{
    margin-top: 1rem;
    .img{
        width: 4rem;
    }
    .name{
        font-size: .35rem;
        text-align: center;
    }
}
.code-img{
    width: 100%;
}
</style>